import { render, staticRenderFns } from "./fbb.vue?vue&type=template&id=531e2c2a"
import script from "./fbb.vue?vue&type=script&lang=js"
export * from "./fbb.vue?vue&type=script&lang=js"
import style0 from "./fbb.vue?vue&type=style&index=0&id=531e2c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports